import { render } from "./AppHeaderAccnt.vue?vue&type=template&id=06cb6d0e&scoped=true"
import script from "./AppHeaderAccnt.vue?vue&type=script&lang=js"
export * from "./AppHeaderAccnt.vue?vue&type=script&lang=js"

import "./AppHeaderAccnt.vue?vue&type=style&index=0&id=06cb6d0e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cb6d0e"]])

export default __exports__